function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var LSBlogList = {
  currentTab: null,
  $container: null,
  isLoading: false,
  isDashboard: false,
  initialize: function initialize(container, currentTab) {
    this.$container = container;
    if (currentTab) this.currentTab = currentTab;
    if (location.href.includes('status')) this.isDashboard = true;
    if (!this.isDashboard && location.hash) this.currentTab = location.hash.replace('#', '');
    this.bind();
    this.renderPosts();
  },
  bind: function bind() {
    var self = this;
    if (!this.isDashboard) {
      window.onhashchange = function () {
        self.selectTab();
        self.fakeLoading().done(function () {
          self.renderPosts();
        });
      };
    }
  },
  loadPosts: function loadPosts() {
    var self = this;
    var dfd = $.Deferred();
    if (clientData.page && clientData.page.allPosts) dfd.resolve();else if (!this.isLoading) {
      this.isLoading = true;
      $.ajax({
        url: Utils.url() + '/blog/',
        data: {
          returnType: 'json'
        }
      }).then(function (resp) {
        if (!clientData.page) clientData.page = {};
        clientData.page.allPosts = resp.data.page.allPosts;
        self.isLoading = false;
        dfd.resolve();
      });
    } else {
      var _self = this;
      setInterval(function () {
        if (!_self.isLoading) dfd.resolve();
      }, 250);
    }
    return dfd.promise();
  },
  selectTab: function selectTab() {
    // from blog page
    if ('' === location.hash) {
      location.hash = '#articles';
      window.history.pushState(null, null, '#articles');
    }
    $('.nav-item .active').removeClass('active');
    if ('#articles' === location.hash) {
      this.currentTab = 'articles';
      $('#nav-item-articles').addClass('active');
    }
    if ('#guides' === location.hash) {
      this.currentTab = 'guides';
      $('#nav-item-guides').addClass('active');
    }
    if ('#calculator' === location.hash) {
      this.currentTab = 'calculator';
      $('#nav-item-calculator').addClass('active');
    }
  },
  setCurrentTab: function setCurrentTab(currentTab) {
    // from dashboard
    this.currentTab = currentTab;
  },
  renderPosts: function renderPosts() {
    var self = this;
    var $container = this.$container;
    $container.empty();
    var $row;
    var i = 0;
    var _iterator = _createForOfIteratorHelper(clientData.page.allPosts[this.currentTab]),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var p = _step.value;
        if (i % 3 === 0) {
          if (i == 0) $row = $('<div class="row mt-2 mb-5"></div>');else $row = $('<div class="row mt-5 mb-5"></div>');
          $container.append($row);
        }
        var thumbnail = p.thumbnail ? p.thumbnail.replace(/{/g, "").replace(/}/g, "").replace("URL", "").trim() :
        // remove twig expression from url
        '/cms/data/content/common/img/blog/thumbnail_default.png';
        var $post = $('<div class="col-md-4 pl-4 pr-4 mb-3">' + '   <a class="card-link" ' + (p.url ? 'href="' + Utils.url() + p.url + '"' : '') + '>' + '       <div class="card card-shadow">' + '           <div class="card-header text-center">' + '               <img src="' + Utils.url() + thumbnail + '" class="' + (p.thumbnail ? 'card-header-img' : '') + '" ' + (p.thumbnail ? '' : 'style="height: 120px;"') + '/>' + '           </div>' + '           <div class="card-body">' + '               <h2 class="title-md pt-0" style="font-size: 27px;line-height: 32px;max-height: 130px;overflow:hidden;">' + '                   ' + p.title + '               </h2>' + '               <p class="text-sm" style="font-weight: 300 !important;line-height: 22px;max-height: 108px;overflow: hidden;">' + '                   ' + $('<span>' + p.preview.substr(0, 214) + '</span>').text() + '...' + '               </p>' + '               <p class="view-more ' + (!p.url ? 'hidden' : '') + '">' + '                   View More <i class="fa fa-angle-right" style="vertical-align: middle;"></i>' + '                   <br />' + '               </p>' + '           </div>' + '           <div class="card-footer text-xs text-gray ' + (!p.url ? 'hidden' : '') + '">' + '               <span style="float: left"><i class="fa fa-calendar"></i>&nbsp;&nbsp;' + p.date + '</span>' + '               <span style="float: right"><i class="fa fa-clock"></i>&nbsp;&nbsp;5 min. read</span>' + '           </div>' + '       </div>' + '   </a>' + '</div>');
        if (this.isDashboard) $('a', $post).bind('click', function (ev) {
          var url = $(ev.target).closest('a').attr('href');
          LSDashboard.openFSIFModal(url, function (iframeUrl, iframe) {
            if (iframeUrl.includes('/blog')) {
              $('.blog-content a', iframe.contentWindow.document).toArray().forEach(function (e) {
                var dst = $(e).attr('href');
                $(e).attr('href', 'about:blank');
                $(e).bind('click', function () {
                  console.log('dst: ' + dst);
                  LSDashboard.showLoading();
                  var dst_clean = dst.replace(Utils.url(), '').replace('/product', '').replace('/checkout', '').replace('//', '/');
                  var newFilingTarget = null;
                  var _iterator2 = _createForOfIteratorHelper(LSDashboard.chLinks),
                    _step2;
                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      var item = _step2.value;
                      if (item.url.includes(dst_clean)) newFilingTarget = item.url;
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                  var _iterator3 = _createForOfIteratorHelper(LSDashboard.hmrcLinks),
                    _step3;
                  try {
                    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                      var _item = _step3.value;
                      if (_item.url.includes(dst_clean)) newFilingTarget = _item.url;
                    }
                  } catch (err) {
                    _iterator3.e(err);
                  } finally {
                    _iterator3.f();
                  }
                  if (newFilingTarget) {
                    var authData = companyHeader.normalizeCompanyData(clientData.orders[0]);
                    var companyNumber = newFilingTarget.includes('company=') ? authData.code.companyNumber.toString() : '';
                    var href = LSUtils.url() + newFilingTarget + companyNumber;
                    companyHeader.onSuccess(href);
                    LSDashboard.hideLoading();
                  } else {
                    LSDashboard.hideLoading();
                    window.location.href = dst;
                  }
                });
              });
            }
          });
          return false;
        });
        $row.append($post);
        i++;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  },
  fakeLoading: function fakeLoading() {
    var $container = this.$container;
    $container.empty();
    $container.append('' + '<div class="text-center mt-5 pt-5" style="height: 500px;">' + '   <img src="' + Utils.url() + '/common/assets/img/ajax-loader.gif" style="width: 32px;"/><br />' + '   <p class="text-md" style="color: gray;"><br />Loading, please wait...</p>' + '</div>');
    var dfd = $.Deferred();
    setTimeout(function () {
      dfd.resolve();
    }, parseInt(Math.random() * 1000) % 2 === 0 ? 250 : 1000);
    return dfd.promise();
  },
  embed: function embed($container) {
    var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var self = this;
    $.ajax({
      url: LSUtils.url() + '/blog/articles',
      data: {
        returnType: 'json'
      },
      success: function success(resp) {
        if (filters) {
          clientData.page.allPosts = {
            articles: []
          };
          var _iterator4 = _createForOfIteratorHelper(resp.data.page.allPosts.articles),
            _step4;
          try {
            var _loop = function _loop() {
              var a = _step4.value;
              if (filters.urls && filters.urls.find(function (e) {
                return e === a.url;
              })) clientData.page.allPosts.articles.push(a);
            };
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        } else {
          clientData.page.allPosts = {
            articles: resp.data.page.allPosts.articles.slice(0, 3)
          };
        }
        self.$container = $container;
        self.currentTab = 'articles';
        self.renderPosts();
      }
    });
  }
};
export { LSBlogList };